import type { PropertySchemaAssociation_DefaultFragment } from "~/features/admin/propertySchemas";
import { PropertySchemasMapper } from "~/features/dataImportProjects/utils/propertySchemasMapper";

import type { CategoryID, ForeignKeyReference, SheetColumn } from "./schemaDesigner/types";

export function buildSheetColumn(params: {
  id: string;
  sheetName: string;
  columnLabel: string;
  columnKind: "data" | "custom";
  property: PropertySchemaAssociation_DefaultFragment;
  order: number;
  categoryId?: CategoryID | null;
  categoryName?: string | null;
  categoryInstanceId?: string | null;
  categoryInstanceLabel?: string;
}): SheetColumn {
  const {
    id,
    sheetName,
    columnLabel,
    columnKind,
    property,
    order,
    categoryId,
    categoryName,
    categoryInstanceId,
    categoryInstanceLabel,
  } = params;

  return {
    sheetName,
    order,
    columnId: id,
    columnLabel,
    columnPath: `${sheetName}!${columnLabel}`,
    columnKind,

    categoryId: categoryId || null,
    categoryName: categoryName || null,
    categoryInstanceId: categoryInstanceId || null,
    categoryInstanceLabel: categoryInstanceLabel || null,

    property: PropertySchemasMapper.propertySchemaAssociation.copyWithoutId(
      PropertySchemasMapper.propertySchemaAssociation.toFormData(property),
    ),
  };
}

export function buildSheetColumnForeignKey(params: {
  id: string;
  sheetName: string;
  columnLabel: string;
  property: PropertySchemaAssociation_DefaultFragment;
  order: number;
  categoryId?: CategoryID | null;
  categoryName?: string | null;
  categoryInstanceId?: string | null;
  categoryInstanceLabel?: string;
  fkRef: ForeignKeyReference;
}): SheetColumn {
  const {
    id,
    sheetName,
    columnLabel,
    property,
    order,
    categoryId,
    categoryName,
    categoryInstanceId,
    categoryInstanceLabel,
    fkRef,
  } = params;

  return {
    sheetName,
    order,
    columnId: id,
    columnLabel,
    columnPath: `${sheetName}!${columnLabel}`,
    columnKind: "foreignKey",

    categoryId: categoryId || null,
    categoryName: categoryName || null,
    categoryInstanceId: categoryInstanceId || null,
    categoryInstanceLabel: categoryInstanceLabel || null,

    property: PropertySchemasMapper.propertySchemaAssociation.copyWithoutId(
      PropertySchemasMapper.propertySchemaAssociation.toFormData(property),
    ),

    fkRef,
  };
}
